export default __webpack_public_path__ + "static/media/avalanche Logo.234db155.svg";